// src/components/Home.js
import React, { useState, useEffect, useRef } from "react";
//import QuestionSocketContext from "./question_socket_context";
import io from "socket.io-client";
import AudioPermission from "../audio/audio_permissions";
import AudioStreamPlayer from "../audio/audio_stream_player";
import SplitPanel from "../common_components/split_panel";
import  {InterviewChatUI, AddMessageToChatUI, AddMessageToChatUIWithInputControl, AddMessageToChatUISideSend } from "./interview_discussion_chat";
import  { UserAIInputAreaUI, UserAreaUI } from "./user_ai_input_area_text";
import { LLDInterviewCountdownTimer } from "./lld_interview_timer";
import { EndInterviewButton } from "../common_components/end_interview_button";
import { getNumber, getWebSocketBaseUrl, JAVA, removeNonEnglishWords } from "../utils/common_utils";
import { arrayBufferToBase64String, detectSilence, float32ToInt16 } from "../audio/audio_utils";
import AudioRecorderWavRecorder from "../audio/audio_recorder_wavrecorder";
import { getAuth } from "../utils/auth_utils";
import { useHref, useParams } from "react-router-dom";
import { MSG_ERROR_PROGRESS_UI, MSG_ERROR_PROGRESS_WITH_TEXT_UI } from "../common_components/common_ui_components";
import { AudioInputProgressBar } from "../common_components/progressbars";
import { MarkdownRenderer } from "../common_components/text_display_utilities";
import { AudioRecorderVAD } from "../audio/audio_recorder_vad_ricky123";
import { ShowInterviewChatOrProblemStatementRow } from "./show_interview_chat_or_problem";
import { QuestionSectionHeader } from "./questions_utility_code";

const QuestionPage = ({question, interviewId, websocketUrl}) => {
  const [message, setMessage] = useState("");
  const [error, setError]=useState("")
  const [showProgress, setShowProgress]=useState(false)
  const [progressText, setProgressText]=useState("")
  const[showInterviewChats, setShowInterviewChats]=useState(true)

  const auth=getAuth()
 // const { questionId } = useParams();
  const questionId=question.questionId
 // const [interviewId, setInterviewId]=useState(0)
  const[sectionId, setSectionId]=useState(0)
  const[sectionName, setSectionName]=useState("")
  //const socket = useContext(QuestionSocketContext);
  const [webSocket, setWebSocket] = useState(null);
  
  const [currentChatInput, setCurrentChatInput]=useState("")
  const[userAreaText,setUserAreaText]=useState("")

  const [response, setResponse] = useState("");
  const [textDelta, setTextDelta] = useState("");
  //const [transcriptionDelta, setResponse] = useState("");
  const [isConnected, setIsConnected] = useState(false);
  const [hasAudioPermission, setHasAudioPermission] = useState(false);
  const [selectedMicrophone, setSelectedMicrophone] = useState(null);
  const[currentTranscriptionLine, setCurrentTranscriptionLine ]=useState("")
  const player=new AudioStreamPlayer()
  const[interviewChatList, setInterviewChatList]=useState([]);

  const audioProgressRef = useRef(null);
  const [showAudioProgressBar, setShowAudioProgressBar]=useState(false)

  /**
   * Indicate end of interview and process
   */
  function timeOver(){
    endInterview()
   /* console.log("interview is over")
    sendCandidateMessage("Interview is over")
    const websocketMessage = {
      text: "Time over"
    };
    webSocket.emit("end-interview",  websocketMessage ); 
    */
  }

  // Connect to WebSocket server
  const handleConnect = () => {
    let url=websocketUrl
    if(!url) url=getWebSocketBaseUrl() 
    console.log("websocket machine url "+url)  
    if (!webSocket) {
      const socketConnection = io(url, { // getWebSocketBaseUrl()
        path: "/websocket"
    });
    // hide this progressbar when first response appears from backend
   // setShowProgress(true)
    // initialize websocket and audio player
    setWebSocket(socketConnection)

      socketConnection.on("connect", () => {
        setIsConnected(true);
        sendAuthData(socketConnection)
        //clearAll()        
        console.log("Connected to WebSocket server:", socketConnection.id);
      });

      socketConnection.on("disconnect", () => {
        setIsConnected(false);        
        console.log("Disconnected from WebSocket server.");
      });

      socketConnection.on("json-response", (data) => {
        console.log("server responded with something")
       // console.log(data)
       // setResponse(data+"\n "+response);
      });

      // need to display failure data so that user can relogin
      socketConnection.on("auth-error", (data) => {
        setShowProgress(false)
        setError(data.message || "Some Error Occured, Please try again.")
        console.log("authentication error occured")
      //  console.log(JSON.stringify(data))
       // setResponse(JSON.stringify(data)+"\n "+response);
        handleDisconnect()
      });

      socketConnection.on("auth-error-retry", (data) => {
        setShowProgress(false)
        console.log("retrying sending auth data")
        sendAuthData(socketConnection)
      });

      socketConnection.on("starting-new-section", (data) => {
        setShowProgress(true)
        setMessage("Loading Next Section ...  <br /> \n "+
          "It can take upto 30 seconds")
        console.log("loading next section")
        //setProgressText("Loading Next Section")
        //audioProgressRef?.current?.updateText("Loading Next Section ...")
        //setShowAudioProgressBar(true)
      });

      socketConnection.on("new-section-started", (data) => {
        console.log("new section started "+JSON.stringify(data))
        let nwSectionId=getNumber(data.sectionId, sectionId+1)
        setSectionId(nwSectionId)
        setSectionName(data.sectionName)
       hideProgressBars()
       setMessage("")
      });
      socketConnection.on("ending-interview",(data)=> {
        //hideProgressBars()
        showInterviewGoingToEnd()
        
      });

      socketConnection.on("interview-ended",(data)=> {
        //hideProgressBars()
        addInterviewChat("interviewer", "Interview has ended.")
        setMessage("Taking You to Final Evaluation Page ...")
        window.location.href = "/evaluations/"+interviewId;
      });

      socketConnection.on("response.audio.delta", (data) => {
        if(showProgress)setShowProgress(false)
        player.addAudioChunk(data)
      });

      socketConnection.on("response.text.delta", (data) => {
        hideProgressBars()
        if(!data) return
        data=removeNonEnglishWords(data).trim()
        //console.log(data)
        setCurrentTranscriptionLine((prevInput) => prevInput + " "+ data)
      });
      socketConnection.on("response.output_item.done", (data) => {
        handleTextResponseFromInterviewer(data=data)
      });
      socketConnection.on("response.audio_transcript.done", (data) => {
        handleTextResponseFromInterviewer(data=data)
       });
       socketConnection.on("problem-statement", (data) => {
        if(!data) return
       // console.log("problem statement received \n "+data)
        question["description"]=data
       }); 

       socketConnection.on("conversation.item.input_audio_transcription.delta", (data) => {
       hideProgressBars()
        if(!data) return
        data=removeNonEnglishWords(data).trim()
        setCurrentTranscriptionLine(data)
       // console.log("conversation.item.input_audio_transcription.delta")
        //console.log(data)
        //addInterviewChat("you", data)
      });
      // getting candidate's audio transcription
      socketConnection.on("conversation.item.input_audio_transcription.completed", (data) => {
        setShowProgress(false)
        data=removeNonEnglishWords(data)
        setCurrentChatInput(
          (prevInput) => prevInput + data + " ")
        setCurrentTranscriptionLine(data)
       // console.log("conversation.item.input_audio_transcription.completed")
       // console.log(data)
        //addInterviewChat("you", data)
      });

      setWebSocket(socketConnection);
    } else {
      console.log("Already connected to WebSocket server.");
    }
  };
  function hideProgressBars(){
    setShowAudioProgressBar(false)
    setShowProgress(false)
  }

  function handleTextResponseFromInterviewer(data){
    hideProgressBars()
    //console.log("response.output_item.done")
   // console.log(data)
    if(!data) return
    addInterviewChat("interviewer", data)
    setCurrentTranscriptionLine(data)
  }

  /**
   * sends authentication data to backend
   */
  function sendAuthData(webSocket){
    let authData={
      userId:auth.userId,
      secretKey:auth.secretKey,
      interviewId: interviewId,
      sectionId:sectionId,
      questionId: question.questionId,
      programmingLanguage: JAVA
    }
    webSocket.emit("auth-data", authData );
  }

  function clearAll(){
    setResponse("")
    setTextDelta("")
  }
  // Disconnect from WebSocket server
  const handleDisconnect = () => {
    if (webSocket) {
        webSocket.disconnect();
      setWebSocket(null);
      setIsConnected(false);
      console.log("Disconnected from WebSocket server.");
    }
  };
  
  const sendCandidateMessage = (msg=message) => {
    //console.log(msg)
    addInterviewChat("you", msg)
    if (!webSocket || !msg) return
      setShowAudioProgressBar(true)
      audioProgressRef?.current?.updateText("Thinking ...", 5000)
      const websocketMessage = {
        text: msg,
        userCodeAreaText: userAreaText
      };
      
      webSocket.emit("json-message",  websocketMessage ); 
      setCurrentTranscriptionLine("")   
  };


 /**
  * @param {*} type interviewer or you
  */
  function addInterviewChat(type, text){
   // console.log(type+" : "+text)
    if(!type||!text) return
    setInterviewChatList((prev) => [...prev, { type: type, text: text }]);
    //interviewChatList.append({"type":type, "text":text})
  }

  /**
   * UI to show when all sections have completed, interview going to end
   * and final evaluation is being prepared.
   */
  function showInterviewGoingToEnd(){
    setShowProgress(true)
    addInterviewChat("interviewer", "Going to end Interview. \n"+
      "It may take 2-3 Minutes to prepare final evaluation report.")
    setMessage("Going to End Interview  <br /> "+
      "It may take 2-3 Minutes to prepare final evaluation report.")
  }

  function endInterview(){
      showInterviewGoingToEnd()
   // addInterviewChat("interviewer", "Interview has ended.")
    if (!webSocket) return
    const websocketMessage = {
      text: ""
    };
    
    //console.log("you:", msg);
    webSocket.emit("end-interview",  websocketMessage );
  }

  function moveToNextSection(){
    if (!webSocket) return
    setShowProgress(true)
    setProgressText("Moving to next section")
    const websocketMessage = {
      text: ""
    };
    console.log("moving to next section");
    webSocket.emit("skip-to-next-section",  websocketMessage );
  }

  function microphoneSelected(microphone){
   // console.log("inside question.js microphone selected ")
    if(!microphone||!microphone.deviceId) return
    setSelectedMicrophone(microphone)
   // console.log(JSON.stringify(microphone))
  }

  function audioDataReceived(audioArr){
    if(!audioArr) return
   // if(!detectSilence(audioArr)){ 
      setShowAudioProgressBar(true)  
      audioProgressRef?.current?.updateText(
        "Speaking ...", 2000)
    //}
    //setCurrentTranscriptionLine("number of bytes received "+audioArr.length)
    //webSocket.emit("audio-message",  audioArr );
   // console.log("number of bytes received "+audioArr.length)
    const websocketMessage = {
      //audioBase64String: arrayBufferToBase64String(audioArr)
      audioBase64String: arrayBufferToBase64String(audioArr)
    };
   // console.log(websocketMessage.audioBase64String)
    if(!webSocket) return
    webSocket.emit("audio-base64-message",  websocketMessage );
   // console.log("emmited audio message of length "+websocketMessage.audioBase64String.length);
      
  }

  useEffect(() => {
    setShowProgress(true)
    console.log("inside question page , interview id "+interviewId)
    console.log(question)
    handleConnect()
  
  }, []); // empty bracket means there are no dependencies which will make useEffect re run

  return (
    <div className="flex flex-col w-full mt-16   
    items-center justify-center overflow-hidden">
      {/* ***** Top sections started ********** */}
      <div className="w-full
       bg-teal-600 text-white flex items-center justify-center ">
        
       { question.heading && question.heading.length>0 &&
        <div className=" font-mono ">
           <QuestionSectionHeader heading={question.heading} 
            currentSection={1+sectionId} 
            totalSectionsCount={question.sectionsCount} 
            sectionName={sectionName}moveToNextSection={moveToNextSection}
           />
       </div>}

       { false && question.description && question.description.length>0 &&
         <div className="text-gray-700 text-sm mx-4 md:pb-8"
         dangerouslySetInnerHTML={{ __html: question.description }}>
          </div>
       }
      <br />  <br />
      </div>
    {/* ***** Top sections ended ********** */}


     {/* ***** Middle Section Started ********** */} 
    <div className="  h-3/5  w-full ">
     {/* flex-grow was not working, so i used h-[calc(100vh-33.33%)] to take remaining space after h-1/3 */} 
     
   <div className="  w-11/12 mx-6 m-2 justify-center items-center"> 
   { <SplitPanel leftPanelWidth={40} 
      leftComponent={
      <div className="flex flex-col">
       {question && question.description &&  <ShowInterviewChatOrProblemStatementRow 
        showInterviewChats={showInterviewChats}
        setShowInterviewChats={setShowInterviewChats}
        />  
        }
        {
         (!question || !question.description) &&
         <div className="text-xl font-bold m-2">
          Discussion 
          </div> 
        }
      {showInterviewChats &&    
      <InterviewChatUI messages={interviewChatList}  />
      }
      {
        !showInterviewChats && question.description &&
          question.description.length>0 &&
         <div className="text-gray-700 prose mt-8 px-4 
          mb-20 h-[50vh] overflow-auto  md:pb-8"
         dangerouslySetInnerHTML={{ __html: question.description }}>
          </div>
      }
      </div>  
      }

      rightComponent={
        <div className="flex flex-col ml-6 w-full items-center justify-center">
         <UserAreaUI setUserText={setUserAreaText} rows={8} 
          maxChars={10000} showCounterAfterChars={5000}/> 
        
        { showAudioProgressBar && 
          <AudioInputProgressBar ref={audioProgressRef} />
        }  

        {/* error success message and progressbar row */}
        {<MSG_ERROR_PROGRESS_UI message={message} error={error} showProgress={showProgress}/>
        }        
          {
          currentTranscriptionLine &&
          <div className="bg-teal-100 mt-4 font-mono text-xl text-gray-700 p-3">
           <MarkdownRenderer content= {currentTranscriptionLine} />
            <br />
          </div>
          }  
        </div>
      }
      />}

      </div> 

      
      <br />   <br /> <br /> <br />
      </div>
    {/* ***** Middle Section Ended ********** */} 

     {/* ***** Third and Footer section started ********** */}
     <div className="fixed bottom-0 w-full h-1/5
      bg-gray-200 text-white flex flex-col justify-center px-6 ">
        
        { false && <MSG_ERROR_PROGRESS_WITH_TEXT_UI message={message} error={error} showProgress={showProgress} progressText={progressText}/>}
          {/* error success message and progressbar row */}
          {false && <MSG_ERROR_PROGRESS_UI message={message} error={error} showProgress={showProgress}/>
        }
      {/*  record and select microphone panel row start*/}
      { 
      <div className="flex flex-row space-x-4 
          items-center justify-center">

      <div className="">
          <EndInterviewButton endInterview={endInterview} />  
      </div> 

      <div className="px-6">
        <LLDInterviewCountdownTimer 
        totalTime={75*60} timeOver={timeOver} />
      </div> 
      
      <div className="px-6 w-1/6">
        <AudioPermission microphoneSelectedCallback={microphoneSelected}/>
      </div> 

      { false && selectedMicrophone && selectedMicrophone.deviceId &&
      <div className="mx-4">
        <AudioRecorderWavRecorder
         selectedMicrophone={selectedMicrophone} 
         audioDataCallback={audioDataReceived} />
        </div>
      }
      { selectedMicrophone && selectedMicrophone.deviceId &&
      <div className="mx-4">
        <AudioRecorderVAD
         selectedMicrophone={selectedMicrophone} 
         audioDataCallback={audioDataReceived} />
        </div>
      }

      <div className="w-1/2 px-4 pr-8">
      
       <AddMessageToChatUISideSend
            inputText={currentChatInput} rows={4}
            setInputText={setCurrentChatInput} 
            submit={sendCandidateMessage}
            maxChars={2000}
            showCounterAfterChars={1500}
             />
      </div> 
       </div>
       }
       {/*  record and select microphone panel row end*/}

       </div>
      {/* ***** Third and Footer section Ended ********** */}
     
     </div>
  );
};

export default QuestionPage;
